import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import { formatCount } from "@/lib/format";

export default function HeroSection() {
  const lead = articles.find((item) => item.hot) ?? articles[0];
  const hotRanking = [...articles].sort((a, b) => b.views - a.views).slice(0, 6);

  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-8 md:px-8 md:py-12">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <Link
              to={`/article/${lead.id}`}
              className="group relative block h-[320px] w-full overflow-hidden rounded-xl bg-foreground-900 md:h-[440px]"
            >
              <img
                src={lead.cover}
                alt={lead.title}
                title={`${lead.title} - ${lead.categoryName}`}
                className="h-full w-full object-cover opacity-90 transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/35 to-transparent"></div>
              <div className="absolute inset-x-0 bottom-0 p-5 md:p-8">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
                    {lead.categoryName}
                  </span>
                  <span className="flex items-center gap-1 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-primary-950">
                    <i className="ri-fire-fill"></i>
                    今日焦点爆料
                  </span>
                </div>
                <h1 className="mt-3 max-w-2xl font-heading text-2xl leading-tight tracking-wide text-background-50 md:text-4xl">
                  {lead.title}
                </h1>
                <p className="mt-3 hidden max-w-xl text-sm leading-relaxed text-background-100/85 md:block">
                  {lead.excerpt}
                </p>
                <div className="mt-4 flex items-center gap-4 text-xs text-background-100/80">
                  <span className="flex items-center gap-1">
                    <i className="ri-user-3-line"></i>
                    {lead.author}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {formatCount(lead.views)}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-line"></i>
                    {formatCount(lead.comments)}
                  </span>
                </div>
              </div>
            </Link>
          </div>

          <div className="flex flex-col rounded-xl border border-background-200 bg-background-50 p-5">
            <div className="flex items-center justify-between">
              <h2 className="flex items-center gap-2 font-heading text-xl tracking-wide text-foreground-950">
                <span className="flex h-6 w-6 items-center justify-center rounded-md bg-primary-500 text-background-50">
                  <i className="ri-fire-fill text-sm"></i>
                </span>
                今日热榜
              </h2>
              <span className="text-xs text-foreground-500">按热度排序</span>
            </div>
            <ol className="mt-4 flex flex-1 flex-col divide-y divide-background-200">
              {hotRanking.map((item, index) => (
                <li key={item.id}>
                  <Link to={`/article/${item.id}`} className="group flex items-start gap-3 py-3">
                    <span
                      className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${
                        index < 3 ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                      }`}
                    >
                      {index + 1}
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="line-clamp-2 text-sm leading-snug text-foreground-800 transition-colors group-hover:text-primary-600">
                        {item.title}
                      </span>
                      <span className="mt-1 flex items-center gap-1 text-xs text-foreground-400">
                        <i className="ri-fire-line"></i>
                        {formatCount(item.views)} 次围观
                      </span>
                    </span>
                  </Link>
                </li>
              ))}
            </ol>
            <Link
              to="/search"
              className="mt-4 flex h-10 items-center justify-center gap-1 rounded-md bg-primary-100 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-200"
            >
              查看全部爆料
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}